/*
 * Copyright 2026 ByOmakase, LLC (https://byomakase.org)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {type Source} from '../source';
import {BaseMainMedia, type BaseMainMediaArgs, type MainMediaState, MainMediaType} from '../media';
import {ObserverBreaker} from '../common/observer-breaker';

export interface AudioFileMainMediaState extends MainMediaState {}

export interface AudioFileMainMediaArgs extends BaseMainMediaArgs {
  source: Source;
}

export class AudioMainMedia extends BaseMainMedia<AudioFileMainMediaState> {
  protected getState(): AudioFileMainMediaState {
    return this._state();
  }
  protected _mainMediaType: MainMediaType = MainMediaType.AUDIO_FILE;

  protected _source: Source;

  protected readonly _destroyBreaker = new ObserverBreaker();

  constructor(args: AudioFileMainMediaArgs) {
    super(args);
    this._source = args.source;
  }

  protected _state(): AudioFileMainMediaState {
    return {
      ...super._getState(),
    };
  }
}
